var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("reconciliation-step-template", {
    attrs: {
      nextStep: _vm.nextStep,
      previousStep: _vm.previousStep,
      loading: _vm.loading
    },
    on: {
      next: _vm.goToNextStep,
      previous: function($event) {
        return _vm.$emit("previous")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
              _vm._v(
                _vm._s(
                  _vm.$l10n.__(
                    "Suppression des premières lignes de votre document"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-80" }, [
              _vm._v(
                _vm._s(
                  _vm.$l10n.__(
                    "Dans certaines banques, les premières lignes du fichier CSV sont vides ou avec des informations qui ne sont pas des transactions (colonnes d’entête par exemple). Afin d’éviter des erreurs de lectures ou des lignes vides, vous pouvez les sélectionner pour les supprimer de l’import. Si vous n’êtes pas concerné, continuez à l’étape suivante."
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "step-container-table border-black"
              },
              [
                _c("table", { staticClass: "table no-border" }, [
                  _c(
                    "tbody",
                    _vm._l(_vm.csv, function(line, index) {
                      return _c(
                        "tr",
                        { key: index, class: { bold: index == 0 } },
                        [
                          _c(
                            "td",
                            { staticClass: "br-1" },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.lineChecked,
                                    callback: function($$v) {
                                      _vm.lineChecked = $$v
                                    },
                                    expression: "lineChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { label: index },
                                      on: { change: _vm.checkLine }
                                    },
                                    [_vm._v(" ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(line, function(column, indexColumn) {
                            return _c(
                              "td",
                              { key: indexColumn, staticClass: "br-1" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(column) +
                                    "\n                        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }